import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Modal from "../../lib/Modal";
import TimeEntryForm from "./TimeEntryForm";
import playBilling from "../../assets/images/svg/play-billing.svg";
import { useTimeTracking } from "../../context/TimeTrackingContext";

const TimeTrackingButton = ({ users, taskId: taskIdProp }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    handleTimeTracking,
    runningNonBillable,
    runningBillable,
    runningEntry,
    time,
  } = useTimeTracking();

  const renderButton = () => {
    if (!runningBillable && !runningNonBillable) {
      return (
        <div className="play-time-tracking">
          <button
            className="billable-hours"
            onClick={(e) => handleTimeTracking(e, "billable")}
          >
            <img src={playBilling} alt="Estimated Points Icon" />
          </button>

          <button
            className="non-billable-hours"
            onClick={(e) => handleTimeTracking(e, "non-billable")}
          >
            <FontAwesomeIcon icon="fa-solid fa-play" />
          </button>
        </div>
      );
    }

    if (runningBillable && runningEntry) {
      return (
        <button
          className="stop-button"
          onClick={(e) => handleTimeTracking(e, "stop-billable")}
        >
          Stop
        </button>
      );
    }

    if (runningNonBillable && runningEntry) {
      return (
        <button
          className="stop-button"
          onClick={(e) => handleTimeTracking(e, "stop-non-billable")}
        >
          Stop
        </button>
      );
    }

    return null;
  };

  const handleTimerClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="timer" onClick={handleTimerClick}>
        <FontAwesomeIcon icon="fa-solid fa-stopwatch" />
        <div className="time-wrapper">{time}</div>
      </div>

      {renderButton()}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        addScrollbarSpace
        overlay={{
          backdropFilter: "none",
          backgroundColor: "transparent",
          zIndex: 2000,
        }}
        content={{
          border: "none",
          height: "auto",
          width: "450px",
          left: "calc(100vw - 257px)",
          bottom: "100%",
          top: "145px",
          borderRadius: "15px",
        }}
      >
        <TimeEntryForm assignedUsers={users} taskId={taskIdProp} />
      </Modal>
    </>
  );
};

export default TimeTrackingButton;
